// React Query keys for the chat feature.
//
// These live outside useChat.ts because chatStreamStore.ts writes streamed
// results straight into the query cache, and importing them from the hook
// module would make the store and the hook circular.

export const sessionsKey = (projectId: string) => ["chat", "sessions", projectId];
export const messagesKey = (sessionId: string) => ["chat", "messages", sessionId];
